(function() {
    function getSectionsToRender() {
        return [
          {
            selector: 'js-main-product',
            sectionId: document.querySelector('[js-main-product]')?.dataset.sectionId
          },
          {
            selector: 'js-text-with-image-section',
            sectionId: document.querySelector('[js-text-with-image-section]')?.dataset.sectionId
          },
          {
            selector: 'js-product-banner-image',
            sectionId: document.querySelector('[js-product-banner-image]')?.dataset.sectionId
          },
          {
            selector: 'js-product-banner-image-2',
            sectionId: document.querySelector('[js-product-banner-image-2]')?.dataset.sectionId
          },
          {
            selector: 'js-product-reviews',
            sectionId: document.querySelector('[js-product-reviews]')?.dataset.sectionId
          },
          {
            selector: 'js-product-recommendations',
            sectionId: document.querySelector('[js-product-recommendations]')?.dataset.sectionId
          }
        ];
    };    

    function renderSections(handle) {
        getSectionsToRender().map(section => {
            fetch(`/products/${handle}?section_id=${section.sectionId}`)
            .then( response => response.text())
            .then(html => {
                const doc = new DOMParser().parseFromString(html, 'text/html');
                
                const elementToReplace = document.querySelector(`[${section.selector}]`);

                if(elementToReplace) {
                    elementToReplace.innerHTML = doc.querySelector(`[${section.selector}]`) ? doc.querySelector(`[${section.selector}]`).innerHTML : '';
                };

                if (section.selector === 'js-main-product') {
                    theme.sections.register('product', theme.Product);
                    theme.collapsibles.init();
                    document.dispatchEvent(new CustomEvent('product-set-slider:init')); 
                    document.dispatchEvent(new CustomEvent('zoom:init')); 
                    document.dispatchEvent(new CustomEvent('add-to-cart:set')); 
                    document.dispatchEvent(new CustomEvent('update-price-with-quantity:init')); 
                    document.dispatchEvent(new CustomEvent('sticky-add-to-cart:init')); 
                    document.dispatchEvent(new CustomEvent('swatch-list-animate:init')); 
                    document.dispatchEvent(new CustomEvent('jdgm:init')); 
                } else if(section.selector === 'js-product-recommendations') {
                    const url = doc.querySelector(`[${section.selector}]`).dataset.url;
                    
                    document.dispatchEvent(new CustomEvent('product-recommendations:init', {
                        detail: {
                            url
                        }
                    })); 
                }
            })
            .catch(function(error) {
                console.log(error);
            });
        });
    };

    document.addEventListener("render-section:init", function({ detail : { handle }}) {
        renderSections(handle);
    });

    class productTabs extends HTMLElement {
        constructor() {
            super();
    
            this.selectors = {
                tabItem: "[js-tab-item]",
                tabPanel: "[js-tab-panel]",
                productItem: "[js-product-item]",
                productColorName: "[js-product-color-name]"
            };
    
            this.classes = {
                activeClass: 'active',
                selectedClass: 'selected',
            }
    
            this.tabItems = this.querySelectorAll(this.selectors.tabItem);
            this.tabPanels = this.querySelectorAll(this.selectors.tabPanel);
            this.productItems = this.querySelectorAll(this.selectors.productItem);
            this.productColorName = this.querySelector(this.selectors.productColorName);
            
            this.init();
        };
    
        init() {
            const self = this;
    
            this.initTabState();
            this.initProductState();
    
            this.tabItems.forEach( item => {
                item.addEventListener('click', function() {
                    self.togglePanel(this);
                })
            });
    
            this.productItems.forEach( item => {
                item.addEventListener('click', function() {
                    self.toggleProduct(this);
                })
            });
        };
        
        initTabState() {
            let hasActiveTab = false;
            this.tabItems.forEach( item => {
                if(item.classList.contains(this.classes.activeClass)) {
                    hasActiveTab = true;
                }
            });
            
            if (hasActiveTab) return;
    
            const firstTabItem = this.querySelector(this.selectors.tabItem);
            const tabId = firstTabItem.dataset.tabId;
    
            firstTabItem.classList.add(this.classes.activeClass);
            this.querySelector(`#${tabId}`).classList.add(this.classes.activeClass);
        };
    
        initProductState() {
            this.tabPanels.forEach( panel => {
                const isSelectedEl = panel.querySelector(`.${this.classes.selectedClass}`);
                if(isSelectedEl) return;
    
               panel.querySelector(this.selectors.productItem)?.classList.add(this.classes.selectedClass);
            });
        };
    
        togglePanel(targetItem) {
            const tabId = targetItem.dataset.tabId;
            const targetPanel = this.querySelector(`#${tabId}`);
            const selectedProduct = targetPanel.querySelector(`.${this.classes.selectedClass}`);
            const handle = selectedProduct.dataset.productHandle;
            const colorName = selectedProduct.dataset.productColorName;
    
            this.updateState(targetItem, targetPanel, true);
            this.updateHistoryState(handle);
            this.updateColorName(colorName);
            renderSections(handle);
        };
    
        toggleProduct(targetProduct) {
            const handle = targetProduct.dataset.productHandle;
            const colorName = targetProduct.dataset.productColorName;
            const currentPanel = this.querySelector(`${this.selectors.tabPanel}.${this.classes.activeClass}`);
            
            this.updateState(targetProduct, currentPanel, false);
            this.updateHistoryState(handle);
            this.updateColorName(colorName);
            renderSections(handle);
        };
    
        updateState(targetEl, targetPanel, isTab) {
            if(isTab) {
                this.tabItems.forEach( item => item.classList.remove(this.classes.activeClass));
                targetEl.classList.add(this.classes.activeClass);
    
                this.tabPanels.forEach( panel => panel.classList.remove(this.classes.activeClass));
                targetPanel.classList.add(this.classes.activeClass)
            }else {
                targetPanel.querySelectorAll(this.selectors.productItem).forEach( item => item.classList.remove(this.classes.selectedClass));
                targetEl.classList.add(this.classes.selectedClass);
            }
        };
    
        updateColorName(colorName) {
            this.productColorName.innerText = colorName ? `- ${colorName}` : '';
        }
    
        updateHistoryState(handle) {
            var newurl = `${window.location.protocol}//${window.location.host}/products/${handle}`;
            window.history.pushState({path: newurl}, '', newurl);
        };
    }
      
    customElements.define('product-tabs', productTabs);
    
    window.addEventListener('popstate', function(e) {
        const handle = e.state.path.split('/products/')[1];
        document.dispatchEvent(new CustomEvent('render-section:init', { detail: { handle }})); 
    });
})()